<div class="clone-modal">
    <div class="clone-header">
        <mat-icon>content_copy</mat-icon>
        <span>Clone Template</span>
        <button mat-icon-button (click)="closed.emit()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-tab-group>
        <!-- Clone to display -->
        <mat-tab label="Clone to Display">
            <div class="tab-body">
                <p class="tab-description">Copy this template to another display — in this site or any other. The clone
                    is independent — future edits won't affect the original.</p>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Target Site</mat-label>
                    <mat-select [(ngModel)]="targetSiteId" (selectionChange)="onTargetSiteChange()">
                        @if (loadingSites()) {
                        <mat-option disabled>Loading...</mat-option>
                        } @else {
                        @for (s of sites(); track s.id) {
                        <mat-option [value]="s.id">{{ s.name }}</mat-option>
                        }
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Target Display</mat-label>
                    <mat-select [(ngModel)]="selectedDisplayId">
                        @if (loadingDisplays()) {
                        <mat-option disabled>Loading...</mat-option>
                        } @else {
                        @for (d of displays(); track d.displayId) {
                        <mat-option [value]="d.displayId">{{ d.deviceName }} {{ d.isOnline ? '●' : '○' }}</mat-option>
                        } @empty {
                        <mat-option disabled>No other displays at this site</mat-option>
                        }
                        }
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>New Template Name (optional)</mat-label>
                    <input matInput [(ngModel)]="newName" placeholder="Leave blank to keep original name" />
                </mat-form-field>

                <div class="form-actions">
                    <button mat-raised-button color="primary" [disabled]="!selectedDisplayId || cloning()"
                        (click)="cloneToDisplay()">
                        @if (cloning()) {
                        <mat-spinner diameter="18" />
                        } @else {
                        <mat-icon>content_copy</mat-icon>
                        }
                        Clone
                    </button>
                    <button mat-button (click)="closed.emit()">Cancel</button>
                </div>
            </div>
        </mat-tab>

        <!-- Apply to site -->
        <mat-tab label="Apply to Site">
            <div class="tab-body">
                <p class="tab-description">Copy this template to <strong>all displays</strong> at a site. Each display
                    gets an independent copy.</p>

                <mat-form-field appearance="fill" class="full-width">
                    <mat-label>Target Site</mat-label>
                    <mat-select [(ngModel)]="selectedSiteId">
                        @if (loadingSites()) {
                        <mat-option disabled>Loading...</mat-option>
                        } @else {
                        @for (s of sites(); track s.id) {
                        <mat-option [value]="s.id">{{ s.name }}</mat-option>
                        }
                        }
                    </mat-select>
                </mat-form-field>

                @if (selectedSiteId) {
                <div class="apply-warning">
                    <mat-icon>warning</mat-icon>
                    <span>This will overwrite existing templates on all displays at <strong>{{
                            getSiteName(selectedSiteId) }}</strong>.</span>
                </div>
                }

                <div class="form-actions">
                    <button mat-raised-button color="warn" [disabled]="!selectedSiteId || applying()"
                        (click)="applyToSite()">
                        @if (applying()) {
                        <mat-spinner diameter="18" />
                        } @else {
                        <mat-icon>publish</mat-icon>
                        }
                        Apply to Site
                    </button>
                    <button mat-button (click)="closed.emit()">Cancel</button>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>